import Vue from 'vue';
import Router from 'vue-router';
import EntityRoutes from './entityRoutes';
import ResetPassword from './views/ResetPassword.vue';
import NewUserSetPassword from './views/NewUserSetPassword.vue';
import qs from 'qs';

Vue.use(Router)

var routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
        path: '/login',
        name: "login",
        component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
        path: '/biosecurity-incidents',
        name: 'biosecurityIncidents',
        component: () => import(/* webpackChunkName: "biosecurity-incidents" */ './views/BiosecurityIncidents.vue')
    },
    {
        path: '/change-password',
        name: "changePassword",
        component: () => import(/* webpackChunkName: "change-password" */ './views/ChangePassword.vue')
    },
    {
        path: '/reset-password',
        name: 'resetPassword',
        component: ResetPassword
    },
    {
        path: '/request-reset-password',
        name: 'requestResetPassword',
        component: () => import(/* webpackChunkName: "request-reset-password" */ './views/RequestResetPassword.vue')
    },
    {
        path: '/new-user-set-password',
        name: 'newUserSetPassword',
        component: NewUserSetPassword
    },
    {
        path: '/users',
        name: 'users',
        component: () => import(/* webpackChunkName: "users" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "users" */ './tables/UsersTable.vue'), pageTitle: 'Users' }
    },
    {
        path: '/master-router',
        name: 'masterRouter',
        component: () => import('./views/MasterRouter.vue')
    },
    {
        path: '/audit-editor/:id',
        name: 'auditEditor',
        component: () => import(/* webpackChunkName: "audit" */ './views/AuditEditor.vue')
    },
    {
        path: '/audit-members',
        name: 'auditMembers',
        component: () => import(/* webpackChunkName: "audit" */ './views/AuditMembers.vue')
    },
    {
        path: '/audit/:id',
        name: 'audit',
        component: () => import(/* webpackChunkName: "audit" */ './editViews/Audit.vue')
    },
    {
        path: '/administrators',
        name: 'administrators',
        component: () => import(/* webpackChunkName: "administrators" */ './views/Administrators.vue')
    },
    {
        path: '/member-profile',
        name: 'memberProfile',
        component: () => import(/* webpackChunkName: "memberProfile" */ './views/MemberProfile.vue')
    },
    {
        path: '/auditor-profile',
        name: 'auditorProfile',
        component: () => import(/* webpackChunkName: "auditorProfile" */ './views/AuditorProfile.vue')
    },
    {
        path: '/inspection/:id',
        name: 'inspection',
        component: () => import(/* webpackChunkName: "inspection" */ './editViews/Inspection.vue')
    },
    {
        path: '/load/:id',
        name: 'load',
        component: () => import(/* webpackChunkName: "load" */ './editViews/Load.vue')
    },
    {
        path: '/biosecurity-organisations',
        name: 'biosecurityOrganisations',
        component: () => import(/* webpackChunkName: "biosecurityOrganisations" */ './views/BiosecurityOrganisations.vue')
    },
    {
        path: '/afflictions',
        name: 'afflictions',
        component: () => import(/* webpackChunkName: "afflictions" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "afflictions" */ './tables/AfflictionsTable.vue'), pageTitle: 'Pests/Diseases' }
    },
    {
        path: '/affliction-sightings',
        name: 'afflictionSightings',
        component: () => import(/* webpackChunkName: "affliction-sightings" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "affliction-sightings" */ './tables/AfflictionSightingsTable.vue'), pageTitle: 'Pest/Disease Sightings' }
    },
    {
        path: '/affliction-sighting-files',
        name: 'afflictionSightingFiles',
        component: () => import(/* webpackChunkName: "affliction-sighting-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "affliction-sighting-files" */ './tables/AfflictionSightingFilesTable.vue'), pageTitle: 'Pest/Disease Sighting Files' }
    },
    // temporarily add these in here while these are restructured
    {
        path: '/oauth-clients',
        name: 'oauthClients',
        component: () => import(/* webpackChunkName: "oauth-clients" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "oauth-clients" */ './tables/OauthClientsTable.vue'), pageTitle: 'Oauth Clients' }
    },
    {
        path: '/oauth-grants',
        name: 'oauthGrants',
        component: () => import(/* webpackChunkName: "oauth-grants" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "oauth-grants" */ './tables/OauthGrantsTable.vue'), pageTitle: 'Oauth Grants' }
    },
    {
        path: '/affliction/:id',
        name: 'affliction',
        component: () => import(/* webpackChunkName: "affliction" */ './editViews/Affliction.vue')
    },
    {
        path: '/affliction-sighting/:id',
        name: 'afflictionSighting',
        component: () => import(/* webpackChunkName: "affliction-sighting" */ './editViews/AfflictionSighting.vue')
    },
    {
        path: '/affliction-report',
        name: 'afflictionReport',
        component: () => import(/* webpackChunkName: "affliction-report" */ './reports/AfflictionReport.vue'),
    },
    {
        path: '/honey-yield-report',
        name: 'honeyYieldReport',
        component: () => import(/* webpackChunkName: "honey-yield-report" */ './reports/HoneyYieldReport.vue'),
    },
    {
        path: '/pollination-density-report',
        name: 'pollinationDensityReport',
        component: () => import(/* webpackChunkName: "pollination-density-report" */ './reports/PollinationDensityReport.vue'),
    },
    {
        path: '/third-party-app-developers',
        name: 'thirdPartyAppDevelopers',
        component: () => import(/* webpackChunkName: "third-party-app-developers" */ './views/ThirdPartyAppDevelopers.vue')
    },
    {
        path: '/container/:id',
        name: 'container',
        component: () => import(/* webpackChunkName: "container" */ './editViews/Container.vue')
    },
    {
        path: '/member/:id',
        name: 'member',
        component: () => import(/* webpackChunkName: "member" */ './editViews/Member.vue')
    },
    {
        path: '/sales',
        name: 'sales',
        component: () => import(/* webpackChunkName: "sales" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sales" */ './tables/SalesTable.vue'), pageTitle: 'Sales' }
    },
    {
        path: '/sale/:id',
        name: 'sale',
        component: () => import(/* webpackChunkName: "sale" */ './editViews/Sale.vue')
    },
    {
        path: '/sale-containers',
        name: 'saleContainers',
        component: () => import(/* webpackChunkName: "sale-containers" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sale-containers" */ './tables/SaleContainersTable.vue'), pageTitle: 'Sale Containers' }
    },
    {
        path: '/sale-files',
        name: 'saleFiles',
        component: () => import(/* webpackChunkName: "sale-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sale-files" */ './tables/SaleFilesTable.vue'), pageTitle: 'Sale Files' }
    },
    {
        path: '/site/:id',
        name: 'site',
        component: () => import(/* webpackChunkName: "site" */ './editViews/Site.vue')
    },
    {
        path: '/sample-set-management',
        name: 'sampleSetManagement',
        component: () => import(/* webpackChunkName: "sample-set-management-page" */ './views/sampleSet/SampleSets.vue')
    },
    {
        path: '/user/:id',
        name: 'user',
        component: () => import(/* webpackChunkName: "user" */ './editViews/User.vue')
    },
    {
        path: '/lab/:id',
        name: 'lab',
        component: () => import(/* webpackChunkName: "lab" */ './editViews/Lab.vue')
    },
    {
        path: '/lab-test-management',
        name: 'labTestManagement',
        component: () => import(/* webpackChunkName: "lab-test-management" */ './views/lab/Labs.vue')
    },
    {
        path: '/test-management',
        name: 'testManagement',
        component: () => import(/* webpackChunkName: "test-management" */ './views/testGroup/TestGroups.vue')
    },
    {
        path: '/sample/:id',
        name: 'sample',
        component: () => import(/* webpackChunkName: "sample" */ './editViews/Sample.vue')
    },

    // otherwise redirect to home
    {
        path: '*',
        redirect: '/'
    }
].concat(EntityRoutes);

// Pass the query string as props into all routes.
routes.forEach(r => r.props = route => Object.assign({}, route.query, r.staticProps));

const router = new Router({
    mode: 'history',
    parseQuery(query) {
        return qs.parse(query, {
            decoder(str, decoder, charset) {
                const strWithoutPlus = str.replace(/\+/g, ' ');
                if (charset === 'iso-8859-1') {
                    // unescape never throws, no try...catch needed:
                    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
                }

                if (/^(\d+|\d*\.\d+)$/.test(str)) {
                    return parseFloat(str)
                }

                const keywords = {
                    true: true,
                    false: false,
                    null: null,
                    undefined,
                }
                if (str in keywords) {
                    return keywords[str]
                }

                // utf-8
                try {
                    return decodeURIComponent(strWithoutPlus);
                } catch (e) {
                    return strWithoutPlus;
                }
            }
        });
    },
    stringifyQuery(query) {
        let result = qs.stringify(query, { encode: false });
        return result ? ('?' + result) : '';
    },
    routes: routes
});

export default router;
